import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';

const CollectionsContext = createContext();

export const useCollections = () => useContext(CollectionsContext);

// Collections are namespaced per user (or "guest"), mirroring favorites.
const keyFor = (user) => `pixiy-collections-${user?.uid || 'guest'}`;

export const CollectionsProvider = ({ children }) => {
    const { user } = useAuth();
    const [collection, setCollection] = useState([]);

    // Load the right list whenever the signed-in user changes.
    useEffect(() => {
        try {
            const raw = localStorage.getItem(keyFor(user));
            setCollection(raw ? JSON.parse(raw) : []);
        } catch {
            setCollection([]);
        }
    }, [user]);

    const persist = (list) => {
        try {
            localStorage.setItem(keyFor(user), JSON.stringify(list));
        } catch {
            /* ignore quota / serialization errors */
        }
    };

    const isInCollection = (kind, id) =>
        collection.some((c) => c.kind === kind && c.id === id);

    const toggleCollection = (kind, item) => {
        setCollection((prev) => {
            const exists = prev.some((c) => c.kind === kind && c.id === item.id);
            const next = exists
                ? prev.filter((c) => !(c.kind === kind && c.id === item.id))
                : [{ kind, id: item.id, item }, ...prev];
            persist(next);
            return next;
        });
    };

    return (
        <CollectionsContext.Provider
            value={{ collection, isInCollection, toggleCollection, count: collection.length }}
        >
            {children}
        </CollectionsContext.Provider>
    );
};

export default CollectionsContext;
